'use client'

import classNames from 'classnames'
import { isFunction } from 'lodash-es'
import { useCallback } from 'react'

export default function RequestButton({
  children,
  onRequest,
  className,
  disabled = false
}) {

  const clickHandle = useCallback(event => {
    isFunction(onRequest) && onRequest(event)
  }, [onRequest])

  return (
    <button
      className={classNames('button-text-primary ml-auto', className)}
      onClick={clickHandle}
      disabled={disabled}
    >
      {children}
    </button>
  )
}
